<template>
  <app-badge
    :color="color"
    :size="size"
  >
    <template
      v-if="showIcon"
      #prefixIcon
    >
      <app-icon
        :color="color"
        :name="icon"
        size="sm"
      />
    </template>
    {{ label }}
  </app-badge>
</template>

<script setup>
import { computed } from 'vue';
import { PayableStatus } from '@/constants/payableStatus.js';
import AppBadge from '@/components/ui/AppBadge.vue';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator(value) {
      return Object.values(PayableStatus).includes(value);
    },
  },
  size: {
    type: String,
    default: 'sm',
    validator(value) {
      return ['sm', 'md', 'lg'].includes(value);
    },
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
  payableMessage: {
    type: String,
    default: 'Payable',
  },
  nonPayableMessage: {
    type: String,
    default: 'Not Payable',
  },
  partiallyPayableMessage: {
    type: String,
    default: 'Partially Payable',
  },
});

const label = computed(() => {
  const labelMap = {
    [PayableStatus.PAYABLE]: props.payableMessage,
    [PayableStatus.PARTIALLY_PAYABLE]: props.partiallyPayableMessage,
    [PayableStatus.NOT_PAYABLE]: props.nonPayableMessage,
  };
  return labelMap[props.status];
});

const color = computed(() => {
  const colorMap = {
    [PayableStatus.PAYABLE]: 'success',
    [PayableStatus.PARTIALLY_PAYABLE]: 'warning',
    [PayableStatus.NOT_PAYABLE]: 'error',
  };
  return colorMap[props.status];
});

const icon = computed(() => {
  const iconMap = {
    [PayableStatus.PAYABLE]: 'check',
    [PayableStatus.PARTIALLY_PAYABLE]: 'alert-circle',
    [PayableStatus.NOT_PAYABLE]: 'alert-circle',
  };
  return iconMap[props.status];
});
</script>
